import { useEffect, useState } from "react";
import API from "../../../../services/api";
import socket from "../../../../services/socket";

function useOrders() {

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchOrders = async () => {

    try {

      setLoading(true);

      const res = await API.get(
        "/orders/provider-orders"
      );

      console.log(
        "============== API RESPONSE =============="
      );

      console.log(res.data);

      console.log(
        "Orders:",
        res.data.orders
      );

      console.log(
        "Count:",
        res.data.count
      );

      console.log(
        "=========================================="
      );

      console.log(
        "Provider Orders API:",
        res.data
      );

      console.table(
        (res.data.orders || []).map(
          (order) => ({
            orderNumber:
              order.orderNumber,

            providerId:
              order.providerId?._id ||
              order.providerId,

            status:
              order.status,

            createdAt:
              order.createdAt,

            customer:
              order.customerSnapshot?.name ||
              order.customerId?.name,
          })
        )
      );

      setOrders(
        res.data.orders || []
      );

    } catch (err) {

      console.error(
        "Provider Orders Error:",
        err
      );

    } finally {

      setLoading(false);

    }

  };


  // =========================================
  // Update Order Status
  // =========================================

  const updateStatus = async (
    id,
    status
  ) => {

    try {

      await API.put(
        `/orders/${id}/status`,
        {
          status,
        }
      );

      await fetchOrders();

    } catch (err) {

      console.error(
        "Update Order Status Error:",
        err
      );

    }

  };


  // =========================================
  // Initial Load + Real-Time Orders
  // =========================================

  useEffect(() => {

    // Initial orders
    fetchOrders();


    // New order received
    const handleNewOrder = (
      order
    ) => {

      console.log(
        "📢 PROVIDER RECEIVED NEW ORDER:",
        order
      );

      // Reload orders from backend
      fetchOrders();

    };


    socket.on(
      "new-order",
      handleNewOrder
    );


    // Cleanup
    return () => {

      socket.off(
        "new-order",
        handleNewOrder
      );

    };

  }, []);


  return {

    orders,

    loading,

    fetchOrders,

    updateStatus,

  };

}

export default useOrders;